import { defineMessages } from 'react-intl';

export default function Messages() {
  const messages = defineMessages({
    login_button_login_text: {
      id: 'login_button_login_text',
      defaultMessage: "Login",
      description: '',
    },
  });
  return messages;
}



// WEBPACK FOOTER //
// ./src/routes/login/Messages.js